import React from "react";
import { classNames } from "../../helpers/classNames";

const ButtonFile = ({
  buttonClasses,
  buttonIcon,
  buttonIconPosition,
  buttonLabel,
  buttonLabelClasses,
  buttonFunction,
  onChange = () => { },
  ...props
}) => {
  return (
    <>
      <div
        className={classNames(
          "flex items-center space-x-2 text-sm sm:text-base text-white h-10 px-3 transition-all duration-200 ease-in-out relative cursor-pointer rounded-md text-center overflow-hidden z-[1] border border-chestnut-rose bg-chestnut-rose shadown-none",
          buttonClasses
        )}
      >
        <input
          type={"file"}
          onChange={onChange}
          className="absolute top-0 right-0 z-10 opacity-0 cursor-pointer w-[1000px] h-full"
        />
        {buttonIconPosition === "left" && (
          <i className={classNames("fa-fw", buttonIcon)}></i>
        )}
        {buttonLabel && (
          <span
            className={classNames("text-sm font-medium", buttonLabelClasses)}
          >
            {buttonLabel}
          </span>
        )}
        {buttonIconPosition === "right" && (
          <i className={classNames("fa-fw", buttonIcon)}></i>
        )}
      </div>
    </>
  );
};

export default ButtonFile;
